import { useTranslation } from '@applyboard/ui-utils';
import { validateSupportedMimeTypes } from '../../../../../common/utils/validateSupportedMimeTypes';

const useFileValidation = () => {
  const { t } = useTranslation();

  /**
   * This is only used for the uploadFile Property inside a FileUpload Component
   */
  const fileValidateUpload = async (
    file: File,
    {
      onError,
      onSuccess,
    }: {
      onSuccess: (fileId: string) => void;
      onError: (errorMessage?: string) => void;
    },
  ) => {
    const isValidFile = await validateSupportedMimeTypes(file);
    if (!isValidFile) {
      onError(t('common.errors.imageDataInvalid'));
      return;
    }
    onSuccess(file.name);
  };

  return { fileValidateUpload };
};

export default useFileValidation;
